import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "materialSetting";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    materialSettingList: {
      list: [],
      total: 0
    },
    dialogFormVisible: false,
    editObj: {}
  },
  actions: {
    //查询物资设置列表;
    async getMaterialSettingData({ commit }, payload) {
      let result = await api.get(
        `/api/Product?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setmaterialSettingList", result.data);
      }
      return result;
    },
    //删除数据
    async delMaterialSettingList(a, payload) {
      let result = await api.delete(`/api/Product/` + payload);
      return result;
    },
    //添加物资
    async addMaterialSetting(a, payload) {
      let result = await api.post("/api/Product", payload);
      return result.data;
    },
    // 根据id 获取物资视图
    async getMaterialView(a, payload) {
      let result = await api.get("/api/Product/" + payload);
      return result.data;
    },
    // 更新物资
    async updateMaterial(a, payload) {
      let result = await api.put("/api/Product", payload);
      return result.data;
    },
    //同步物资
    async syncMaterials(a, payload) {
      let result = await api.post("/api/Product/SyncMaterials", payload);
      return result;
    }
  },
  mutations: {
    setmaterialSettingList(state, payload) {
      payload.list = payload.list.map(item => {
        if (item.type == 1) {
          item.type = "--";
        }
        return item;
      });
      state.materialSettingList = payload;
    },
    setDialogFormVisible(state, payload) {
      state.dialogFormVisible = payload;
    },
    setDialogObj(state, payload) {
      state.editObj = payload;
    }
  },
  getters: {}
});

export default moduleName;
